// Keep this list aligned with the routes registered in App.js.
export const PAGE_ROUTES = [
  { path: '/', title: 'AI 代充，找大师兄' },
  { path: '/order/confirm', title: '确认订单' },
  { path: '/order/success', title: '订单结果' },
  { path: '/detail/plus-upgrade', title: '订单详情' },
  { path: '/orders', title: '历史订单' },
  { path: '/settings', title: '账号设置' },
  { path: '/change-password', title: '修改密码' },
  { path: '/support', title: '帮助中心' },
  { path: '/customer-service', title: '联系客服' },
  { path: '/after-sales', title: '售后服务' },
  { path: '/after-sales/invoice', title: '免费领取 Invoice' },
  { path: '/anti-ban-guide', title: '账号使用指南' },
  { path: '/upgrade-guide', title: '升级与使用教程' },
  { path: '/terms', title: '服务条款' },
  { path: '/privacy', title: '隐私政策' },
  { path: '/disclaimer', title: '免责声明' },
];
